import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'reflect-metadata';

import { MainApp } from './main-app';

import './util/error-handler';

/* tslint:disable: variable-name */
const render = (MainApp: any) => {
    ReactDOM.render(<MainApp />, document.getElementById('app-root'));
};

if (navigator.userAgent.indexOf('Trident') >= 0) {
    console.log('App startup skipped for IE');
} else {
    render(MainApp);

    // enabling hot reload
    if (module.hasOwnProperty('hot')) {
        // accepting all files
        (module as any).hot.accept('./main-app.tsx', () => {
            // eslint-disable-next-line global-require
            render(require('./main-app.tsx').MainApp);
        });
    }
}
